declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        __globalErrorReporterRegistered?: boolean;
    }
}

// Prevent web-feature-ui from registering its global error handler
// This must be called before importing anything from @servicetitan/web-feature-ui
export const preventGlobalErrorReporter = () => {
    window.__globalErrorReporterRegistered = true;
};

// Call immediately when this module loads
preventGlobalErrorReporter();
